import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import React from "react";

export const LinearScale: ReactTFC<{ paused: boolean; scale: number }> = props => {
  return (
    <span
      className={props.paused ? "" : "is-playing"}
      style={{
        transform: `scaleX(${props.scale})`,
      }}
      css={css`
        pointer-events: none;
        transform-origin: left;

        .is-playing {
          transition: 0.5s linear transform;
        }

        width: 100%;
        height: 3px;
        background-color: ${CSS_COLORS.Green};
        position: absolute;
        left: 0;
        top: calc(50% - 1px);
      `}
    />
  );
};
